/** @jsxImportSource @emotion/react */

import { CopyIconBox, UrlInputWrapper } from './styles';

import { Copy } from 'lucide-react';
import { toast } from 'react-toastify';
import { theme } from 'styles/theme/theme';
import { DivProps } from '../../../../../../typings';
import { increaseClickArea } from 'modules/template-editor/ui/pages/styles';
import EmptyButton from 'ud-ui/components/empty-button';
import UDText from 'ud-ui/components/text';

interface IProps extends DivProps {
  value: string;
}

function UrlInput(props: IProps) {
  const { value, ...rest } = props;

  const handleCopy = () => {
    navigator.clipboard.writeText(value).then(() => {
      toast.success('Ссылка скопирована');
    });
  };

  return (
    <UrlInputWrapper {...rest}>
      <UDText color={theme.colors.DarkYellow} style={{ fontSize: 18 }} type={'subhead'}>
        {value}
      </UDText>
      <CopyIconBox className="url-icon-box">
        <EmptyButton
          onClick={handleCopy}
          color={theme.colors.DarkYellow}
          hoverColor={theme.colors.AccentNaplesYellow}
          icon={<Copy size={20} className="url-copy-icon" />}
          css={increaseClickArea({ height: 60, width: 60 })}
        />
      </CopyIconBox>
    </UrlInputWrapper>
  );
}

export default UrlInput;
